export enum rbacActions {

    ViewDashboard = 'ViewDashboard',

    ListAccounts = 'ListAccounts',
    GetAccount = 'GetAccount',
    CreateAccount = 'CreateAccount',
    UpdateAccount = 'UpdateAccount',
    DeleteAccount = 'DeleteAccount',
    // FNP-575: re-assign a Customer's owning account (re-points ownerAccountId,
    // the FNP-121 deletion-cascade key) — gated separately from UpdateAccount.
    ReassignCustomerOwner = 'ReassignCustomerOwner',

    ListApplications = 'ListApplications',
    GetApplication = 'GetApplication',
    CreateApplication = 'CreateApplication',
    UpdateApplication = 'UpdateApplication',
    DeleteApplication = 'DeleteApplication',
    // FNP-1007: mark an application DECOMMISSIONED when its infrastructure is
    // verifiably already gone. Gated on its own id rather than folded into
    // DeleteApplication because the blast radius is the opposite: this destroys
    // NOTHING and only corrects a record, while it does move that record to a
    // terminal state under a renamed identity. Admin-only, matching the
    // server's @aws_cognito_user_pools(cognito_groups: ["admin"]).
    MarkApplicationDecommissioned = 'MarkApplicationDecommissioned',

    ListOrganizations = 'ListOrganizations',
    GetOrganization = 'GetOrganization',
    CreateOrganization = 'CreateOrganization',
    UpdateOrganization = 'UpdateOrganization',
    DeleteOrganization = 'DeleteOrganization',

    ListOrganizationAccounts = 'ListOrganizationAccounts',
    GetOrganizationAccount = 'GetOrganizationAccount',
    CreateOrganizationAccount = 'CreateOrganizationAccount',
    UpdateOrganizationAccount = 'UpdateOrganizationAccount',
    DeleteOrganizationAccount = 'DeleteOrganizationAccount',
    DeactivateOrganizationAccount = 'DeactivateOrganizationAccount',

    ListAccountApplications = 'ListAccountApplications',
    GetAccountApplication = 'GetAccountApplication',
    CreateAccountApplication = 'CreateAccountApplication',
    UpdateAccountApplication = 'UpdateAccountApplication',
    DeleteAccountApplication = 'DeleteAccountApplication',

    ListApplicationAccounts = 'ListApplicationAccounts',
    GetApplicationAccount = 'GetApplicationAccount',
    CreateApplicationAccount = 'CreateApplicationAccount',
    UpdateApplicationAccount = 'UpdateApplicationAccount',
    DeleteApplicationAccount = 'DeleteApplicationAccount',

    ListApplicationProducts = 'ListApplicationProducts',
    GetApplicationProduct = 'GetApplicationProduct',
    CreateApplicationProduct = 'CreateApplicationProduct',
    UpdateApplicationProduct = 'UpdateApplicationProduct',
    DeleteApplicationProduct = 'DeleteApplicationProduct',

    ListUsers = 'ListUsers',
    GetUser = 'GetUser',
    CreateUser = 'CreateUser',
    UpdateUser = 'UpdateUser',
    DeleteUser = 'DeleteUser',

    GetSupport = 'GetSupport',
    GetPlatformHealth = 'GetPlatformHealth',

    GetWorkflow = 'GetWorkflow',
    CreateWorkflow = 'CreateWorkflow',
    UpdateWorkflow = 'UpdateWorkflow',
    DeleteWorkflow = 'DeleteWorkflow',

    ListPlaybooks = 'ListPlaybooks',
    GetPlaybook = 'GetPlaybook',
    CreatePlaybook = 'CreatePlaybook',
    UpdatePlaybook = 'UpdatePlaybook',
    DeletePlaybook = 'DeletePlaybook',

    ListPhases = 'ListPhases',
    GetPhase = 'GetPhase',
    CreatePhase = 'CreatePhase',
    UpdatePhase = 'UpdatePhase',
    DeletePhase = 'DeletePhase',

    ListSteps = 'ListSteps',
    GetStep = 'GetStep',
    CreateStep = 'CreateStep',
    UpdateStep = 'UpdateStep',
    DeleteStep = 'DeleteStep',

    ListWorkflowGroups = 'ListWorkflowGroups',
    GetWorkflowGroup = 'GetWorkflowGroup',
    CreateWorkflowGroup = 'CreateWorkflowGroup',
    UpdateWorkflowGroup = 'UpdateWorkflowGroup',
    DeleteWorkflowGroup = 'DeleteWorkflowGroup',

    ListActionGroups = 'ListActionGroups',
    GetActionGroup = 'GetActionGroup',
    CreateActionGroup = 'CreateActionGroup',
    UpdateActionGroup = 'UpdateActionGroup',
    DeleteActionGroup = 'DeleteActionGroup',

    ListActions = 'ListActions',
    GetAction = 'GetAction',
    CreateAction = 'CreateAction',
    UpdateAction = 'UpdateAction',
    DeleteAction = 'DeleteAction',

    ListPipelines = 'ListPipelines',
    GetPipeline = 'GetPipeline',
    CreatePipeline = 'CreatePipeline',
    UpdatePipeline = 'UpdatePipeline',
    DeletePipeline = 'DeletePipeline',

    ListCodePipelines = 'ListCodePipelines',
    GetCodePipeline = 'GetCodePipeline',
    DeleteCodePipeline = 'DeleteCodePipeline',
    ImportCodePipeline = 'ImportCodePipeline',
    ImportAllCodePipelines = 'ImportAllCodePipelines',
    MigrateCodePipeline = 'MigrateCodePipeline',
    CleanupMigratedPipeline = 'CleanupMigratedPipeline',
    AnalyzeRepository = 'AnalyzeRepository',
    ProvisionPipeline = 'ProvisionPipeline',
    ReprovisionPipeline = 'ReprovisionPipeline',
    GetStackStatus = 'GetStackStatus',

    ListCodeRepositories = 'ListCodeRepositories',

    ListDeploymentAccountGroups = 'ListDeploymentAccountGroups',
    GetDeploymentAccountGroup = 'GetDeploymentAccountGroup',

    ListPlaybookActionGroups = 'ListPlaybookActionGroups',
    GetPlaybookActionGroup = 'GetPlaybookActionGroup',
    CreatePlaybookActionGroup = 'CreatePlaybookActionGroup',
    UpdatePlaybookActionGroup = 'UpdatePlaybookActionGroup',
    DeletePlaybookActionGroup = 'DeletePlaybookActionGroup',

    ListApplicationScreenshots = 'ListApplicationScreenshots',
    GetApplicationScreenshot = 'GetApplicationScreenshot',
    CreateApplicationScreenshot = 'CreateApplicationScreenshot',
    UpdateApplicationScreenshot = 'UpdateApplicationScreenshot',
    DeleteApplicationScreenshot = 'DeleteApplicationScreenshot',

    ListExecutions = 'ListExecutions',
    ViewExecution = 'ViewExecution',
    ExecutePlaybook = 'ExecutePlaybook',
    CancelExecution = 'CancelExecution',

    // FNP-859: Autonomous Testing (flexinet-testing-api). Deliberately NOT reusing
    // the ListActions / GetAction / ... names above — those belong to the
    // workflows-api action-group domain and mean something else entirely.
    ListTestingActions = 'ListTestingActions',
    GetTestingAction = 'GetTestingAction',
    CreateTestingAction = 'CreateTestingAction',
    UpdateTestingAction = 'UpdateTestingAction',
    DeleteTestingAction = 'DeleteTestingAction',
    SetTestingActionStatus = 'SetTestingActionStatus',

    // FNP-995: the handler registry — what the deployed canary can actually
    // PERFORM, as opposed to what the Action catalog above claims. Read-only,
    // so there is no Create/Update/Delete counterpart: the registry is a
    // projection of code and the only way to change it is to ship a handler.
    //
    // ⚠️ Declared in flexinet-console-avp-infra's schema too. An action the app
    // sends but the policy store never declares evaluates against nothing and
    // DENYs, and the admin catch-all would hide that — the two must stay in step.
    ListRegisteredActions = 'ListRegisteredActions',

    // FNP-967: authored test definitions — an ORDERED sequence of steps, where an
    // Action is a single handle. Same naming convention as the FNP-859 ids above:
    // prefixed so they cannot collide with the workflows-domain action names.
    // SetTestDefinitionStatus is its own id because publishing a test definition
    // (DRAFT -> ACTIVE) is a different authority from editing its steps.
    ListTestDefinitions = 'ListTestDefinitions',
    GetTestDefinition = 'GetTestDefinition',
    CreateTestDefinition = 'CreateTestDefinition',
    UpdateTestDefinition = 'UpdateTestDefinition',
    DeleteTestDefinition = 'DeleteTestDefinition',
    SetTestDefinitionStatus = 'SetTestDefinitionStatus',

    ListTestingPersonas = 'ListTestingPersonas',
    GetTestingPersona = 'GetTestingPersona',
    CreateTestingPersona = 'CreateTestingPersona',
    UpdateTestingPersona = 'UpdateTestingPersona',
    DeleteTestingPersona = 'DeleteTestingPersona',

    // FNP-861: the observability half of Autonomous Testing. Same naming
    // convention as the FNP-859 ids above: prefixed so they cannot collide with
    // the workflows-domain action names.
    //
    // FNP-969 REVERSES the "no Delete id" half of FNP-861's original position.
    // That position assumed the executor owned the TestObservation lifecycle and
    // would delete rows itself. It never did: a sweep of src/canary, src/tick and
    // src/triage in flexinet-testing-api finds `deleteTestObservation` ONLY in
    // comments — there is no call site anywhere. The capability was therefore
    // reachable from nowhere, and clearing an environment required a direct
    // DynamoDB script, breaking the platform's "no direct table writes" rule to
    // do something entirely legitimate.
    //
    // The module stays APPEND-ONLY: delete is not an edit affordance, and there
    // is still no Create/Update id. An observation is evidence — you may discard
    // the whole record, never rewrite what it says.
    ListTestObservations = 'ListTestObservations',
    GetTestObservation = 'GetTestObservation',
    DeleteTestObservation = 'DeleteTestObservation',

    // FNP-904: the TRIAGE half — defect signatures, one row per defect rather
    // than per observation. List/Get are read, and Update is the ONE human write
    // in this domain (status + jiraKey only). It is a separate id on purpose:
    // seeing what is broken and declaring it acknowledged or filed are different
    // authorities, and there is deliberately no Create/Delete because the sweep
    // produces these rows from evidence — a hand-authored signature would carry
    // a fingerprint that matches nothing.
    // FNP-969 adds Delete, which is ADDITIVE rather than a reversal: the API
    // mutation was added the same day and verified live. It is a separate id from
    // Update because they answer different questions, and the UI must not let one
    // be mistaken for the other:
    //   - Update  = TRIAGE. "I acknowledge this / I filed it as FNP-x."
    //   - Resolve = the SWEEP's conclusion from an absence of occurrences. It is
    //               @aws_iam and has no console id at all — "this is fixed" is
    //               evidence-based, never a click.
    //   - Delete  = CLEARING AN ENVIRONMENT. It discards the signature and its
    //               history. It is NOT "this defect is fixed".
    ListDefectSignatures = 'ListDefectSignatures',
    GetDefectSignature = 'GetDefectSignature',
    UpdateDefectSignature = 'UpdateDefectSignature',
    DeleteDefectSignature = 'DeleteDefectSignature',

    ListSyntheticUsers = 'ListSyntheticUsers',
    GetSyntheticUser = 'GetSyntheticUser',
    // FNP-969: RETIRE, not delete. There is deliberately no DeleteSyntheticUser
    // id because there is no deleteSyntheticUser mutation — retiring TOMBSTONES
    // the row (lifecycleStage DELETED / state TOMBSTONED) and the row outlives the
    // account it describes. The roster is the only thing distinguishing synthetic
    // from organic activity (there is no isSynthetic flag on Account), so purging
    // rows would make that separation permanently unanswerable.
    RetireSyntheticUser = 'RetireSyntheticUser',

    // FNP-969 / FNP-966: Test Runs — one instance of a TestDefinition executed by
    // one synthetic user during one wake. READ-ONLY in the console by design:
    // openTestRun / closeTestRun / abandonTestRun are all @aws_iam, written by the
    // executor and the abandon sweep. A run is a statement that work happened, not
    // something a human declares, so there are no write ids here at all.
    ListTestRuns = 'ListTestRuns',
    GetTestRun = 'GetTestRun',

    // FNP-891 / FNP-893: platform-wide operational controls (the registration
    // kill-switch and its siblings). Viewing is separated from operating on
    // purpose — the list is deliberately broad so the controls stay visible to
    // anyone who might need to reason about them, while actually moving one is
    // a platform-wide action and is gated on its own id.
    ListPlatformControls = 'ListPlatformControls',
    OperatePlatformControl = 'OperatePlatformControl',

}


export const actions = Object.values(rbacActions);

export const actionConstants = actions.reduce((acc, action) => {
    acc[action.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '_' : '') + match.toLowerCase())
              .toUpperCase()] = action;
    return acc;
}, {} as Record<string, string>);